import React, { useEffect } from "react";
import "../styles/Disclaimer.css";
import { motion } from "framer-motion";
import MusicCard from "./MusicCard";
import "../styles/MusicList.css";

const MusicList = ({ songs, title, fetched, modelResponse }) => {
  useEffect(() => {}, [modelResponse]);
  // Add debugging for songs data
  useEffect(() => {}, [songs]);

  if (!songs || songs.length === 0) {
    if (!fetched) return null;
    let contextMsg = "";
    if (title && title.toLowerCase().includes("mood")) {
      contextMsg = "No songs found for your emotion input.";
    } else if (title && title.toLowerCase().includes("location")) {
      contextMsg = "No songs found for your location.";
    } else if (title && title.toLowerCase().includes("city")) {
      contextMsg = "No songs found for your city/country input.";
    } else {
      contextMsg = "No songs found for your request.";
    }
    return (
      <div className="error-message-container">
        <div className="error-content">
          <span role="img" aria-label="warning" style={{ marginRight: 8 }}>
            ⚠️
          </span>
          <p>{contextMsg}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Disclaimer Section */}

      <motion.div
        className="music-list-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        {modelResponse && (
          <div className="ai-model-response-card">
            <h3>🎧 AI Model Analysis</h3>
            {/* <div className="ai-model-input-text">
            <strong>User Text:</strong> <span>{modelResponse.input_text}</span>
          </div> */}
            <div className="ai-model-emotions-list">
              <strong>Detected Emotions 🎵 :</strong>
              <ul>
                {modelResponse.emotions && modelResponse.emotions.length > 0 ? (
                  modelResponse.emotions
                    .sort((a, b) => b.probability - a.probability)
                    .map((emotion, idx) => (
                      <li key={idx} className="ai-emotion-item">
                        <span className="ai-emotion-label">
                          {emotion.label}
                        </span>
                        <span className="ai-emotion-probability">
                          {emotion.probability.toFixed(2)}%
                        </span>
                      </li>
                    ))
                ) : (
                  <li>No emotions detected.</li>
                )}
              </ul>
            </div>
          </div>
        )}
        <h2>{title || "Recommended Songs"}</h2>
        <div className="music-grid">
          {songs.map((song, index) => (
            <motion.div
              key={song.id || index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <MusicCard song={song} />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </>
  );
};

export default MusicList;
